import { render, staticRenderFns } from "./skuList.vue?vue&type=template&id=6651bf90&"
import script from "./skuList.vue?vue&type=script&lang=js&"
export * from "./skuList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports